// export { default as userCenter } from "./userCenter/userCenter.vue";
export const userCenter = (r) => require.ensure([], () => r(require("./userCenter/userCenter.vue")), "userCenter");
export const personalData = (r) => require.ensure([], () => r(require("./personalData/personalData.vue")), "personalData");
